<template>
    <div class="ImageSlider">
        <Hooper
                ref="hooper"
                :wheel-control="false"
                :infinite-scroll="false"
                :group="group"
        >
            <Slide v-for="(image, index) of images" :key="index">
                <div class="ImageSlider__image" :style="getBg(image)" @click="$router.push({name: 'object', params: {id}})">

                </div>
            </Slide>
            <Pagination v-if="showPagination && images.length > 1" mode="fraction" slot="hooper-addons"></Pagination>
            <Navigation v-if="showNavigation && images.length > 1" slot="hooper-addons"></Navigation>
        </Hooper>
    </div>
</template>

<script>
    import {Hooper, Slide, Pagination, Navigation} from 'hooper';
    import 'hooper/dist/hooper.css'

    export default {
        name: "ImageSlider2",
        components: {
            Hooper,
            Slide,
            Pagination,
            Navigation
        },
        props: {
            group: String,
            images: Array,
            id: [Number, String],
            showNavigation: {
                type: Boolean,
                default: true,
            },
            showPagination: {
                type: Boolean,
                default: true,
            },
        },
        methods: {
            getBg(image){
                return {'background-image': `url('${image}')`}
            }
        }
    }
</script>

<style lang="scss">
    .ImageSlider {
        height: 100%;
        background-color: $grayLight;

        &__image {
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            flex-shrink: 0;
            cursor: pointer;
        }

        .hooper {
            height: 100%;
            outline: none;
        }

        .hooper-prev, .hooper-next {
            height: 48px;
            width: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #E8E9EB;
            border-radius: 50%;
            flex-shrink: 0;
            padding: 0;
        }

        .hooper-slide {
            width: 100%;
        }

        .hooper-prev {
            left: 32px;
        }

        .hooper-next {
            right: 32px;
        }

        .hooper-pagination {
            bottom: 24px;
            padding: 8px 16px;
            background: rgba($primary, 0.4);
            backdrop-filter: blur(4px);
            border-radius: 90px;

            font-size: 16px;
            font-weight: 500;
            color: $white;

            span {
                margin: 0 2px;
            }

            .hooper-indicators {
                height: 36px;
                display: flex;
                align-items: center;

                .hooper-indicator {
                    height: 8px;
                    width: 8px;
                    border-radius: 50%;
                    flex-shrink: 0;
                    margin: 0 3px;
                    box-shadow: 0 2px 9px rgba(0, 0, 0, 0.02), 0 1px 4px rgba(0, 0, 0, 0.16);
                    background-color: $white;

                    &.is-active {
                        height: 12px;
                        width: 12px;
                        background-color: $white;
                    }
                }
            }
        }
    }
</style>